export interface Land {
    code: string
    naam: string
}

export interface Gemeente {
    nis: string
    naam: string
    deelgemeente: string
    postcode: string
}

export interface Straat {
    nis: string
    id: string
    naam: string
}

export interface GebouwRef {
    objectId: string
    huisNummer: string
    bus: string
}

export type Adres = {
    objectId: string;
    straat: string;
    huisNummer: string;
    adres2: string;
    postcode: string;
    gemeente: string;
    nis: string;
    regio: string;
    land: string;
}

export interface Perceel {
    objectId: string
    municipalityCode: string
    municipalityName: string
    departmentCode: string
    departmentName: string
    sectionCode: string
    perceelnummer: string
    capakey: string
    grondnummer: string
    exponent: string
    macht: string
    bisnummer: string
}

export type AdresSuggestieItem = {
    formattedAddress: string
    municipality: string
    zipcode: string
    thoroughfarename: string
    housenumber: string
}

export type AdresSuggestResponse = {
    available: boolean
    items: AdresSuggestieItem[]
}

export type AdresMatchResponse = {
    available: boolean
    confident: boolean
    gemeente: string
    nis: number
    straat: string
    huisNummer: string
    postcode: string
}

export const zoekLanden = async (
    q: string): Promise<Land[]> => {

    var query = q.substring(0, 1).toUpperCase() + q.substring(1, q.length).toLowerCase()

    var res = await fetch('/api/geo/land/' + query)
    if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`)
    }
    const data = await res.json()
    return data
}

export async function zoekAdresSuggesties(q: string): Promise<AdresSuggestResponse> {
    try {
        const res = await fetch(`/api/geo/adres/suggestie?q=${encodeURIComponent(q)}`)
        if (!res.ok) return { available: false, items: [] }
        return await res.json()
    } catch (e) {
        return { available: false, items: []}
    }
}

export async function matchAdres(q: string): Promise<AdresMatchResponse> {
    try {
        const res = await fetch(`/api/geo/adres/match?formatted=${encodeURIComponent(q)}`)
        if (!res.ok) return { gemeente: "", huisNummer: "", nis: 0, postcode: "", straat: "", available : false, confident : false }
        return await res.json()
    } catch (e) {  // Verder doen?
        return {gemeente: "", huisNummer: "", nis: 0, postcode: "", straat: "", available : false, confident : false }
    }
}



export const zoekGemeenten = async (
    q: string): Promise<Gemeente[]> => {

    var query = q.substring(0, 1).toUpperCase() + q.substring(1, q.length).toLowerCase()

    var res = await fetch('/api/geo/gemeente/' + query)
    if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`)
    }
    const data = await res.json()
    return data
}

export const zoekStraten = async (
    q: string, nis?: string): Promise<Straat[]> => {
    var res = await fetch('/api/geo/' + nis + '/straat/' + q)
    if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`)
    }
    const data = await res.json()
    return data
}

export const zoekGebouwen = async (
    nis: string, straat?: string, q?: string): Promise<GebouwRef[]> => {

    var res = await fetch('/api/geo/' + nis + '/adressen?s=' + encodeURI(straat) + '&q=' + q)
    if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`)
    }
    const data = await res.json()
    return data
    }

export const findNis = async (q: string): Promise<string> => {
    var res = await fetch('/api/geo/findnis/' + encodeURI(q))
    if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`)
    }
    const nis = await res.text()
    return nis
}

export const findPostcode = async (q: string): Promise<string> => {
    var res = await fetch('/api/geo/findpostcode/' + encodeURI(q))
    if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`)
    }
    const nis = await res.text()
    return nis
}


export const findGemeente = async (nis: string): Promise<string> => {
    var res = await fetch('/api/geo/findgemeente/' + nis)
    if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`)
    }
    const gemeente = await res.text()
    return gemeente
}



export const zoekPerceelOp = async (objectId: string): Promise<Perceel> => {
    var res = await fetch('/api/geo/percelen/' + objectId)
    if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`)
    }
    const data = await res.json()
    return data
}